module.exports = __webpack_public_path__ + "static/testimonialDashBack-f08e71abf6e4c6330ea5b4ba557489dd.png";